import { Stack } from "react-bootstrap";
import { Localization, SessionContext, SettingsManager } from "@viamap/viamap2-common";
import { useContext, useEffect, useState } from "react";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton, GlassButtonRow } from "../../components/GlassButtons";
import { message } from "../../components/Message";
import { createPortal } from "react-dom";
import { ProtectedFeature } from "src/components/ProtectedFeature";
import { keyValueObject } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, WindowId } from "src/WindowManager/WindowState";
import { KeyValueTable } from "src/propertyInfoTemplates/PropertyComponents";
import { ConfirmationDialog } from "src/components/ConfirmationDialog";
import { ApplicationStateContext } from "src/states/ApplicationState";
import { JobTypeUserAccessRights, initialize, JobsContext, JobType, getMyAccessRights, JobActionType } from "./JobState";
// import { JobSettingsDefBoth, JobTypeSettingsDefBoth } from "./JobSettingsDef.Bothtsx";

import { JobServiceInterface } from "./JobServiceInterface";
import { JobInstiantiationTypeEditor } from "./JobInstiantiationTypeEditor";

type Props = {
  showWindow: number;
  onFormClose: () => void;
};




export function JobInstiationTypeDialog(props: Props) {
  const { state: jobsState, dispatch: jobsDispatch } = useContext(JobsContext);
  const { hasAccessToFeature } = useContext(ApplicationStateContext);
  const { state: sessionState } = useContext(SessionContext);
  // let {dispatch: appMessageDispatch} = useContext(AppMessagesContext);
  const { dispatch: windowDispatch } = useWindowContext();

  const [showProjectEditor, setShowProjectEditor] = useState<JobType | null>(null);
  const [newProject, setNewProject] = useState<boolean>(false);
  const [confirmDelete, setConfirmDelete] = useState<string | undefined>();

  const [emptyProject, setEmptyProject] = useState<JobType>({
    id: "",
    name: "",
    description: "",
    // esIndexName: "",
    ownerUser: sessionState.userRef,
    ownerOrganization: sessionState.customerRef,
    settings: {},
    active: true,
    allowedUsersWithRoles: {},
    allowedOrganizationsWithRoles: {},
    protected: false
  });

  useEffect(() => {
    // Load Projects State
    if (!jobsState.isInitialized) {
      jobsDispatch(initialize(
        SettingsManager.getSystemSetting("jobs.jobTypeElasticIndex", ""),
        sessionState.userName));
    }
  }, [])

  useEffect(() => {

    setEmptyProject({
      id: "",
      name: "",
      description: "",
      // esIndexName: "",
      ownerUser: sessionState.userRef,
      ownerOrganization: sessionState.customerRef,
      settings: {},
      active: true,
      allowedUsersWithRoles: { [sessionState.userRef]: [JobTypeUserAccessRights.Admin] },
      allowedOrganizationsWithRoles: {},
      protected: false
    })

  }, [sessionState.customerRef, sessionState.userRef])

  if (!props.showWindow) {
    return <></>
  }


  function filterProjectsByAccessRights(project: JobType): boolean {
    if (hasAccessToFeature(Feature.JobModuleGlobalAdmin)) {
      return true;
    };
    let accessRights = getMyAccessRights(project, sessionState.userRef, sessionState.customerRef);
    if (accessRights && accessRights.includes(JobTypeUserAccessRights.Admin)) {
      return true;
    }
    return false;
  }

  const JobTypeList = () => {

    return (
      <>
        <Stack gap={3}>
          {/* <h3>Projects. Selected = {bnboState.selectedProject ? bnboState.selectedProject.name : ""}</h3> */}
          <KeyValueTable>
            <tbody>
              <tr className="bold">
                <td>Id</td>
                <td>Project</td>
                <td>Protected</td>
                <td>Actions</td>
              </tr>
              {(jobsState.availableJobTypesList || []).filter(filterProjectsByAccessRights).map((project, idx) => {
                return (
                  <tr key={project.id + idx}>
                    <td>{project.id}</td>
                    <td>{project.name}</td>
                    <td>{project.protected ? "yes" : ""}</td>
                    <td>
                      <GlassButtonRow>
                        <GlassButton
                          onClick={() => {
                            // Load projects in case any has changed by other user
                            jobsDispatch({
                              type: JobActionType.LoadJobTypes,
                              callback: (availableJobTypesList: JobType[]) => {
                                setShowProjectEditor(availableJobTypesList?.find((a) => a.id === project.id) || null);
                              }
                            });
                          }}>{Localization.getText("Edit")}</GlassButton>
                        {!project.protected ? (
                          <GlassButton
                            onClick={() => {
                              setConfirmDelete(project.id)
                            }}>{Localization.getText("Delete")}
                          </GlassButton>
                        ) : null}
                      </GlassButtonRow>
                    </td>
                  </tr>
                )
              })
              }
            </tbody>
          </KeyValueTable>
        </Stack>
      </>
    )
  }



  const handleAddItem = async (projectId, project: JobType): Promise<void> => {
    return new Promise((resolve, reject) => {
      let instanceElasticIndex = SettingsManager.getSystemSetting("jobs.jobTypeElasticIndex", undefined);
      if (!instanceElasticIndex) {
        reject("Missing system setting jobs.jobTypeElasticIndex");
      }
      let jobInterface = new JobServiceInterface({
        userRef: sessionState.userRef,
        userName: sessionState.userName,
        organizationId: sessionState.customerRef,
        languageCode: Localization.getLanguage() as "da" | "en"
      });
      let settings = jobInterface.getSettingsForJob(jobsState.selectedJobType?.serverTypeName ?? "Error no job type name").settings;

      // Settings value for new project is default value 
      let defaultSettings = settings.reduce((acc, setting) => {
        acc[setting.key] = setting.default;
        return acc;
      }, {} as keyValueObject);
      let defaultValues: JobType = {
        ...project,
        ownerUser: sessionState.userRef,
        ownerOrganization: sessionState.customerRef,
        settings: defaultSettings,
        active: true,
      }
      jobsDispatch({
        type: JobActionType.AddJobType,
        payload: {
          id: projectId,
          item: defaultValues
        }
      });
      resolve();
    });
  }



  return (
    <AdvancedDragModal
      PosDefault={{ width: "1000px", left: "50%", transform: "translateX(-50%)", top: "1rem" }}
      title={"Job Typer"}
      onClose={() => windowDispatch(closeWindow(WindowId.JobsAdminDialog))}
      allowUserMiniMize={true}
    >
      <ADModalBody>
        {/* <Tabs defaultActiveKey={"JobTypes"}> */}

        {/* <Tab eventKey={"JobTypes"} title={"Job Typer"}> */}
        <ProtectedFeature feature={Feature.JobModuleGlobalAdmin}>
          <Stack gap={3}>
            <JobTypeList />

            <GlassButtonRow >
              <GlassButton
                onClick={() => {
                  setNewProject(true);
                }}>Ny Job Type</GlassButton>


            </GlassButtonRow>
          </Stack>
        </ProtectedFeature>
        {/* </Tab>

          <Tab eventKey={"Instance"} title={"Lav Instanser"} >

            <br />
            <JobInstantiateDialog/>
            
          </Tab> */}
        {/*
          <Tab eventKey={"JobInstances"} title={"Vis Instanser"}>
            <ProtectedFeature feature={Feature.JobModuleGlobalAdmin}>
              <InstancesList />
              <GlassButton
                // disabled={bnboState.selectedProject?.protected}
                onClick={() => {
                  reloadStatus();
                }}>Refresh</GlassButton>
                <GlassButton
                // disabled={bnboState.selectedProject?.protected}
                onClick={() => {
                  let jobInterface = new JobServiceInterface({
                    userRef: sessionState.userRef,
                    userName: sessionState.userName,
                    organizationId: sessionState.customerRef,
                    languageCode: Localization.getLanguage() as "da" | "en"
                 });
                 jobInterface.StopServer()
                }}>Stop Server</GlassButton>
            </ProtectedFeature>
          </Tab>
*/}
        {/* </Tabs> */}
      </ADModalBody>
      {showProjectEditor ? createPortal(
        <JobInstiantiationTypeEditor show={true} title={"Edit Job Type"} value={showProjectEditor} onClose={function (): void {
          setShowProjectEditor(null);
        }} onChange={function (project: JobType): void {
          jobsDispatch({
            type: JobActionType.UpdateJobType,
            payload: {
              id: project.id,
              item: project
            }
          });
          setShowProjectEditor(null);
        }} />
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}
      {newProject ? createPortal(
        <JobInstiantiationTypeEditor
          show={true}
          title="Ny jobtype"
          value={emptyProject}
          onClose={function (): void {
            setNewProject(false);
          }}
          onChange={function (project: JobType): void {
            handleAddItem(project.id, project)
              .then(() => {
                message.info("Ny jobtype oprettet");
              })
              .catch((e) => {
                message.error(e.message || e);

              })
              .finally(() => {
                setNewProject(false);
              })
          }}
        />
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}
      {confirmDelete ? createPortal(
        <ConfirmationDialog showWindow={1} header="Delete Project"
          onSubmit={() => {
            jobsDispatch({
              type: JobActionType.DeleteJobType,
              payload: {
                id: confirmDelete
              }
            });
            setConfirmDelete(undefined);
          }}
          onCancel={() => {
            setConfirmDelete(undefined);
          }} >
          <>
            Er du sikker på at du vil slette projektet {confirmDelete}?
          </>
        </ConfirmationDialog>
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}


    </AdvancedDragModal>
  )



}
